module.exports = __webpack_public_path__ + "static/img/enlarge-square-3.dcaf56a8.png";